module.exports = __webpack_public_path__ + "media/dah.0e8be122.wav";